import axios from 'axios'
export default {
  deleteNotification ({state, commit}, value) {
    let http = axios.create({
      timeout: 200000,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    http.post('http://homologacao2.hotvia.com.br/imagens/index.php', value).then((response) => {
      commit('deleteNotification', response.data)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/notificacaoTabs/actions.js